<template>
  <Card accent class="kpi-card">
    <template v-if="loading">
      <v-skeleton-loader type="text" class="painel-skeleton mb-2" width="90" height="14" />
      <v-skeleton-loader type="text" class="painel-skeleton mb-3" width="130" height="34" />
      <v-skeleton-loader v-if="badge" type="chip" class="painel-skeleton" width="60" />
    </template>
    <template v-else>
      <div class="kpi-label">
        <v-icon v-if="icon" small color="#C7C7D8" class="mr-1">{{ icon }}</v-icon>{{ label }}
      </div>
      <div class="kpi-value">{{ value }}</div>
      <div v-if="badge" class="kpi-badge" :style="badge.style">
        <v-icon v-if="badge.icon" small :color="badge.style.color">{{ badge.icon }}</v-icon>
        {{ badge.text }}
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'KpiCard',
  components: {
    Card: () => import('@/views/components/card'),
  },
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    icon: { type: String, default: null },
    badge: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.kpi-card {
  height: 100%;

  .kpi-label {
    font-size: 13px;
    color: #C7C7D8;
    margin-bottom: 8px;
    display: flex;
    align-items: center;

    ::v-deep .v-icon {
      color: #C7C7D8 !important;
    }
  }

  .kpi-value {
    font-size: 28px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 12px;
  }

  .kpi-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 20px;
  }
}

// Skeleton overrides — dark surface (#1D1D29 cards)
.painel-skeleton {
  border-radius: 6px;
  overflow: hidden;

  ::v-deep .v-skeleton-loader__image,
  ::v-deep .v-skeleton-loader__text,
  ::v-deep .v-skeleton-loader__chip,
  ::v-deep .v-skeleton-loader__heading,
  ::v-deep .v-skeleton-loader__bone {
    background: rgba(255, 255, 255, 0.08) !important;
    margin: 0 !important;
  }

  ::v-deep .v-skeleton-loader__bone::after {
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.06),
      transparent
    ) !important;
  }
}
</style>
